if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        // モーダル内カルーセル表示のため、モーダルクリック拡大表示画像紐づけ処理をコメントアウト
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
          element.classList.remove('swiper-slide-active');
          element.classList.remove('swiper-slide-prev');
          element.classList.remove('swiper-slide-next');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.classList.add('swiper-slide-active');

        // activeクラスがあるスライドのインデックスを取得
        var activeSlideIndex = findActiveSlideIndex(modalSwiper);

        // アニメーションを無効にする
        modalSwiper.params.noSwiping = true;

        if (activeSlideIndex !== -1) {
          // activeクラスがあるスライドが見つかった場合、そのスライドに移動
          modalSwiper.slideTo(activeSlideIndex, 0, false);
        } else {
          // activeクラスが見つからない場合の処理
          console.log('Active slide not found.');
        }

        // アニメーションを再度有効にする
        modalSwiper.params.noSwiping = false;

        // Swiperのスライドを順番に調べて、activeクラスを持つスライドのインデックスを取得する関数
        function findActiveSlideIndex(swiper) {
          var slides = swiper.slides;
          for (var i = 0; i < slides.length; i++) {
            if (slides[i].classList.contains('active')) {
              return i; // activeクラスを持つスライドのインデックスを返す
            }
          }
          return -1; // activeクラスを持つスライドが見つからない場合は-1を返す
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
